import {Organization} from '@catalyst-zero/company-schema/types/Organization'
import {Breadcrumb, enrichNavigationNodesWithIds} from '@mds/mds-reactjs-library'
import {IntlShape} from 'react-intl'
import {Link, Location, NavigateFunction} from 'react-router-dom'

import {hasAssetsCategory, hasCompanyCategory, hasProductsCategory} from '../../../utils/organization'

export interface GeneratorContext {
  intl: IntlShape
  location: Location
  navigate: NavigateFunction
  organization?: Organization
}

export const createOrganizationsNavConfig = ({intl, location, navigate}: GeneratorContext) =>
  enrichNavigationNodesWithIds([
    {
      label: (
        <Breadcrumb>
          <Link to="organizations">{window.czConfig.CUSTOMER_NAME}</Link>
        </Breadcrumb>
      ),
      topGroupLevel: true,
      items: [
        {
          label: intl.formatMessage({id: 'organizations.section.title'}),
          locator: () => /organizations/.test(location.pathname),
          onClick: () => navigate('/organizations')
        },
        {
          label: intl.formatMessage({id: 'organization.section.factorLibrary.title'}),
          locator: () => /factor-library/.test(location.pathname),
          onClick: () => navigate('/factor-library')
        }
      ]
    }
  ])

const companyEntry = ({intl, navigate, location}: GeneratorContext) => ({
  label: intl.formatMessage({id: 'organization.section.company.title'}),
  locator: () => /organizations\/.*\/company/.test(location.pathname),
  onClick: () => navigate('company')
})

const assetsEntry = ({intl, navigate, location}: GeneratorContext) => ({
  label: intl.formatMessage({id: 'organization.section.assets.title'}),
  locator: () => /organizations\/.*\/assets/.test(location.pathname),
  onClick: () => navigate('assets')
})

const productsEntry = ({intl, navigate, location}: GeneratorContext) => ({
  label: intl.formatMessage({id: 'organization.section.products.title'}),
  locator: () => /organizations\/.*\/products/.test(location.pathname),
  onClick: () => navigate('products')
})

const generateNavigationNodes = ({organization, ...entryContext}: GeneratorContext) => [
  {
    label: (
      <Breadcrumb>
        <Link to="../organizations">{window.czConfig.CUSTOMER_NAME}</Link>
        <Link to={`organizations/${organization?.id}`}>{organization!.organizationName}</Link>
      </Breadcrumb>
    ),
    topGroupLevel: true,
    items: [
      ...(hasCompanyCategory(organization) ? [companyEntry(entryContext)] : []),
      ...(hasAssetsCategory(organization) ? [assetsEntry(entryContext)] : []),
      ...(hasProductsCategory(organization) ? [productsEntry(entryContext)] : []),
      {
        label: entryContext.intl.formatMessage({id: 'organization.section.factorLibrary.title'}),
        locator: () => /organizations\/.*\/factor-library/.test(location.pathname),
        onClick: () => entryContext.navigate('factor-library')
      }
    ]
  }
]

export const createOrganizationOrganizationIdNavConfig = (context: GeneratorContext) =>
  context.organization ? enrichNavigationNodesWithIds(generateNavigationNodes(context)) : []
